import React from 'react';
import CheckBox from '@react-native-community/checkbox';
import { CheckBox as KCheckbox } from '@ui-kitten/components';
export const Native = CheckBox;
export const Kitten = (props) => {
    const { children, ...rest } = props;
    return (<KCheckbox {...rest}>
    {children}
  </KCheckbox>);
};
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=Checkbox.js.map